import React, { useState, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import {
  getPendingRequests,
  getUserById,
  matchedUsers,
  updateConnectUsers,
  UpdateUser,
} from "../../src/Component/api/api";
import HomeConsultant from "../Component/HomeConsultant/HomeConsultant";
import "../UserPage/UserHomePage.css";
import banner from "../assets/images/home_banner.jpg";
import { environment } from "../environments/environments";
import MemberProfileModal from "../Component/MemberProfileModal/MemberProfileModal";
import { useDispatch } from "react-redux";
import { loadNotInterestedFromAPI } from "../Component/redux/slices/NotInterestedSlice";
import userIcon from "../assets/images/user-icon.png";

const UserHomePage = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [alluserdata, setUserdata] = useState("");
  const [currUser, setCurrUser] = useState("");
  const [currUserallData, setcurrUserallData] = useState("");
  const [fevUsers, setFevUsers] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [request, setRequest] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [selectedMemberId, setSelectedMemberId] = useState(null);

  const ViewMemberDetail = (memberId) => {
    setSelectedMemberId(memberId);
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
    setSelectedMemberId(null);
  };

  const fetchUserData = useCallback(async () => {
    setIsLoading(true);
    try {
      const userData = JSON.parse(localStorage.getItem("currentUser"));
      const _id = userData?.id || userData?._id;

      if (_id) {
        const currentUser = await getUserById({ user_id: _id });
        setCurrUser(currentUser?.data);
        setcurrUserallData(currentUser);

        dispatch(
          loadNotInterestedFromAPI(currentUser?.data?.marked_as_not_interested)
        );

        if (currentUser?.data?.activeSubscriptionStatus === "0") {
          navigate("/SubscriptionBlurPage");
          return;
        }

        setFevUsers(currentUser?.data?.fav_users || []);
      }
    } catch (error) {
      console.error("Error fetching user data:", error);
    } finally {
      setIsLoading(false);
    }
  }, [navigate, dispatch]);

  const getUserdata = useCallback(async () => {
    setIsLoading(true);
    try {
      const userData = JSON.parse(localStorage.getItem("currentUser"));
      setCurrUser(userData);
      const _id = userData?.id || userData?._id;
      if (_id) {
        const currentUser = await matchedUsers({ user_id: _id });
        console.log("matchUser", JSON.stringify(currentUser));
        setUserdata(currentUser);
      }
    } catch (error) {
      console.error("Error fetching user data:", error);
    } finally {
      setIsLoading(false);
    }
  }, []);

  const PendingRequests = useCallback(async () => {
    try {
      const userData = JSON.parse(localStorage.getItem("currentUser"));
      setCurrUser(userData);
      const _id = userData?.id || userData?._id;
      const pendingRequests = await getPendingRequests({ user_id: _id });
      setRequest(pendingRequests);
    } catch (error) {
      console.error("Error fetching pending requests:", error);
    }
  }, []);

  const handleHeartClick = async (id) => {
    let updatedFavorites = fevUsers.includes(id)
      ? fevUsers.filter((userId) => userId !== id)
      : [...fevUsers, id];
    setFevUsers(updatedFavorites);
    await updateUserFavorites(updatedFavorites);
  };

  const updateUserFavorites = async (updatedFavorites) => {
    try {
      const values = {
        user_id: currUser?.id || currUser?._id,
        fav_users: updatedFavorites,
      };
      const response = await UpdateUser(values);
      if (!response?.success) {
        alert("Error updating favorites");
        setFevUsers((prevFevUsers) => [...prevFevUsers]);
      }
    } catch (error) {
      console.error("Error updating user:", error);
    }
  };

  const RequestUser = async (interestedUserId, confirms) => {
    try {
      const values = {
        user_id: currUser?.id || currUser?._id,
        interested_user: interestedUserId,
        confirm: confirms,
      };
      await updateConnectUsers(values);
    } catch (error) {
      console.error("Error requesting user:", error);
    }
  };

  useEffect(() => {
    fetchUserData();
    getUserdata();
    PendingRequests();
  }, [fetchUserData, getUserdata, PendingRequests]);

  const isSubscriptionInactive = currUser?.activeSubscriptionStatus === "0";

  return (
    <div className="user-home-container">
      <div className="bannerdiv">
        <img src={banner} alt="Banner" className="banner-image" />
      </div>

      {isLoading ? (
        <div className="scroll-container">
          <div className="loader"></div>
        </div>
      ) : alluserdata?.matched_users?.length > 0 ? (
        <div className="matched-section-wrapper">
          <div className="scroll-container">
            <div className="heading-text-div">
              <h1 className="heading-text">People who match your profile</h1>
            </div>
            <div className="horizontal-scroll">
              {/* {alluserdata.matched_users.map((match, index) => (
                <div className="user-card" key={index}>
                  <div
                    className="user-image"
                    onClick={() => ViewMemberDetail(match?.id)}
                    style={{
                      backgroundImage: `url(${
                        match?.more_images?.[0]
                          ? `${environment.url}/uploads/users/${match.more_images[0]}`
                          : ""
                      })`,
                    }}
                  >
                    <div className="text-overlay">
                      <p>{match?.name}</p>
                      <p>{match?.age} Years</p>
                    </div>
                  </div>
                </div>
              ))} */}
              {alluserdata.matched_users.map((match, index) => {
                const hasImageConsent =
                  match?.pre_consent_for_displaying_images;
                const userImage =
                  hasImageConsent && match?.more_images?.[0]
                    ? `${environment.url}/uploads/users/${match.more_images[0]}`
                    : userIcon; // fallback image

                return (
                  <div className="user-card" key={index}>
                    <div
                      className="user-image"
                      onClick={() => ViewMemberDetail(match?.id)}
                      style={{
                        backgroundImage: `url(${userImage})`,
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                      }}
                    >
                      <div className="text-overlay">
                        <p>{match?.name}</p>
                        <p>{match?.age} Years</p>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>

          {isSubscriptionInactive && (
            <div className="blur-overlay">
              <div className="locked-message">
                <p>To view full profiles, please subscribe to a plan.</p>
                <button
                  className="upgrade-button"
                  onClick={() => navigate("/subscription")}
                >
                  Upgrade Now
                </button>
              </div>
            </div>
          )}
        </div>
      ) : (
        <div className="user-home-no-match">
          <p>{alluserdata?.message}</p>
        </div>
      )}

      {/* <div className="counselor-section">
        {currUserallData?.data?.councelling?.plans?.counselling !== "0" &&
        currUserallData?.data?.councelling !== null ? (
          <>
            <div className="counselor-header">
              <h2>Counsellor</h2>
              <button onClick={() => navigate("/consult")}>See All</button>
            </div>
            <HomeConsultant />
          </>
        ) : (
          <div className="counselor-blurred">
            <div className="counselor-header">
              <h2>Counsellor</h2>
              <button disabled>See All</button>
            </div>
            <HomeConsultant />
            <div className="blur-overlay">
              <div className="locked-message">
                <p>Upgrade your subscription plan to access this feature</p>
                <button
                  className="upgrade-button"
                  onClick={() =>
                    navigate("/subscription", {
                      state: { counsellingEnabled: 1 },
                    })
                  }
                >
                  Upgrade Now
                </button>
              </div>
            </div>
          </div>
        )}
      </div> */}
      <div className="counselor-section">
        {currUserallData?.data?.councelling?.plans?.counselling !== "0" &&
          currUserallData?.data?.councelling !== null ? (
          <>
            {/* <div className="counselor-header">
              <h2>Counsellor</h2>
              <button onClick={() => navigate("/consult")}>See All</button>
            </div> */}
            <div className="section-header">
              <h2>Counsellor</h2>
              <span
                className="see-all"
                onClick={() => navigate("/Sidebar/Consult")}
              >
                See All
              </span>
            </div>
            <HomeConsultant />
          </>
        ) : (
          <div className="counselor-blurred">
            {/* <div className="counselor-header">
              <h2>Counsellor</h2>
              <button disabled>See All</button>
            </div> */}

            <div className="consultant-container">
              <HomeConsultant />
              <div className="blur-overlay">
                <div className="locked-message">
                  <p>Upgrade your subscription plan to access this feature</p>
                  <button
                    className="upgrade-button"
                    onClick={() =>
                      navigate("/SubscriptionPlans", {
                        state: { counsellingEnabled: 1 },
                      })
                    }
                  >
                    Upgrade Now
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>

      {showModal && (
        <MemberProfileModal memberId={selectedMemberId} onClose={closeModal} />
      )}
    </div>
  );
};

export default UserHomePage;
